import { Sort } from '@monolith/legacy/types/sorting';
import { SortColumns } from '../types/contacts.types';

export const ADVANCED_FILTERS: string[] = [
  'firstOrderInterval',
  'ordering.lastOrderedAt',
  'totalCompletedOrdersRange',
  'ordering.totalSpent.amount',
  'hasProductsInCart',
  'registered',
  'ordering.activitySignal',
  'retailer.contact.country',
  // language facet is a virtual helper facet, on the backend it is calculating the correct language based on `contact.language` facet and `retailer.language` facet
  'retailer.shopType',
  'communication.emailing.subscriptionStatus',
  // freeShippingInterval facet is a virtual helper facet, on the backend it is calculating the correct value based on `commercialTerms.freeShippingForBrandUntil` facet and current date
  'freeShippingInterval',
  'ordering.liftEligible',
  'contact.source',
  'qrCampaignSourceId',
  'discount',
  'commercialTerms.hasRepeatOffer',
  'retailer.aksPlus.active',
  'repeatOffer',
  // cards_facets is a virtual field
  'cards_facets',
];

export const DEFAULT_SORTING = { [SortColumns.total_spent]: Sort.Desc };

export const FACETS: string[] = [
  ...ADVANCED_FILTERS,
  'language',
  'segment',
  'communication.emailing.contactedRecently', // it is a virtual field
];

export const ADVANCED_FILTERS_UI = [
  {
    groupName: 'orders-history',
    items: [
      {
        filterNames: ['firstOrderInterval', 'ordering.lastOrderedAt', 'totalCompletedOrdersRange', 'ordering.totalSpent.amount'],
      },
      { groupName: 'items-in-cart', filterNames: ['hasProductsInCart'] },
    ],
  },
  {
    groupName: 'shop-details',
    items: [
      { filterNames: ['registered', 'ordering.activitySignal'] },
      {
        groupName: 'shop-information',
        filterNames: ['retailer.contact.country', 'retailer.shopType'],
      },
      {
        filterNames: ['communication.emailing.subscriptionStatus', 'freeShippingInterval'],
      },
    ],
  },
  {
    groupName: 'purchasing-benefit',
    items: [
      {
        filterNames: ['ordering.liftEligible'],
      },
      {
        filterNames: ['contact.source'],
      },
      {
        filterNames: ['discount'],
      },
      {
        filterNames: ['retailer.aksPlus.active'],
      },
      {
        filterNames: ['repeatOffer'],
      },
    ],
  },
];
